import React from "react";
import ReceiptMaker from "./ReceiptMaker";
import HeroSection from "../../utils/HeroSection";
import HowTo from "./HowTo";
export default function ReceiptMakerIndex() {
  return (
    <>
      <HeroSection
        title="online receipt maker"
        description="The best free receipt maker on the web. Create a receipt for your business in minutes."
      />
      <ReceiptMaker />
      <HowTo />
    </>
  );
}
